import React from 'react';
import { ArrowRight, Mail } from 'lucide-react';

const Consulting = ({ data, email }) => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="consulting" className="section-container consulting-section">
      <div className="content-wrapper">
        <div className="section-header">
          <h2 className="section-title">{data.title}</h2>
        </div>

        <div className="v2-consulting-card">
          <p className="consulting-pitch">{data.pitch}</p>

          <div className="v2-consulting-focus">
            {data.focusAreas.map((area) => (
              <span className="v2-consulting-chip" key={area.title}>
                {area.title}
              </span>
            ))}
          </div>

          <div className="consulting-cta">
            <button
              className="btn-primary"
              onClick={() => scrollTo(data.ctaPrimary.target)}
            >
              <span>{data.ctaPrimary.label}</span>
              <ArrowRight size={16} />
            </button>
            <a
              href={`mailto:${email}?subject=Data%20%26%20AI%20Consulting%20Enquiry`}
              className="btn-secondary"
            >
              <span>{data.ctaSecondary.label}</span>
              <Mail size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Consulting;
